import { makeStyles } from "@material-ui/core";
import * as React from "react";
import TextEditor from "../TextEditor";

const useStyles = makeStyles({
  container: {
    background: "#ffffff",
    border: "1px solid #e6e6e6",
    borderRadius: 3,
    marginBottom: "32px",
    minHeight: 110,
    padding: "8px 0 0 0"
  }
});

interface IOwnProps {
  dataTestId?: string;
  placeholder?: string;
  defaultValue?: string;
  onChange: (arg0: string) => void;
  readOnly?: boolean;
  maxChars?: number;
  onCharCountChange?: (count: number) => void;
  invalid?: boolean;
}

const Comment = ({
  dataTestId,
  placeholder,
  defaultValue,
  onChange,
  readOnly,
  maxChars,
  onCharCountChange,
  invalid
}: IOwnProps) => {
  const classes = useStyles();

  const handleTextChange = React.useCallback(
    (data: string) => {
      onChange(data);
    },
    [onChange]
  );

  return (
    <div className={classes.container}>
      <TextEditor
        enableGrow
        dataTestId={dataTestId}
        defaultValue={defaultValue}
        readOnly={readOnly}
        disabled={false}
        onChange={handleTextChange}
        placeholder={placeholder}
        invalid={invalid}
        maxChars={maxChars}
        onCharCountChange={onCharCountChange}
      />
    </div>
  );
};

export default React.memo(Comment);
